module.exports = __webpack_public_path__ + "img/mdf.8d5dace5.svg";